import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'icon-credit-bureau',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    d="M12 12.0005L5.00197 6.33643C4.57285 5.98911 3.93869 6.0528 3.63599 6.51448C3.06678 7.38261 2.62413 8.35486 2.34078 9.41234C0.911364 14.747 4.07719 20.2304 9.41185 21.6598C14.7465 23.0892 20.2299 19.9234 21.6593 14.5887C23.0887 9.25406 19.9229 3.77069 14.5882 2.34127C11.9556 1.63587 9.28684 2.04955 7.0869 3.2907"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
                <path
                    opacity="0.5"
                    d="M9.86583 5.59455C9.47284 5.72543 9.26035 6.15012 9.39124 6.54311C9.52212 6.9361 9.9468 7.14858 10.3398 7.0177L9.86583 5.59455ZM18 12H17.25C17.25 14.8995 14.8995 17.25 12 17.25V18V18.75C15.7279 18.75 18.75 15.7279 18.75 12H18ZM12 18V17.25C9.1005 17.25 6.75 14.8995 6.75 12H6H5.25C5.25 15.7279 8.27208 18.75 12 18.75V18ZM12 6V6.75C14.8995 6.75 17.25 9.1005 17.25 12H18H18.75C18.75 8.27208 15.7279 5.25 12 5.25V6ZM6 12H6.75C6.75 10.7313 7.19908 9.56944 7.94772 8.66185L7.36914 8.18461L6.79057 7.70738C5.82849 8.87375 5.25 10.3703 5.25 12H6ZM10.1028 6.30613L10.3398 7.0177C10.8606 6.84424 11.4186 6.75 12 6.75V6V5.25C11.2554 5.25 10.5376 5.37084 9.86583 5.59455L10.1028 6.30613Z"
                    fill="currentColor"
                />
            </svg>
        </ng-template>
    `,
})
export class IconCreditBureauComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
